import React, { memo } from "react";
import { Button, Modal } from "../../../components/ui";

// Session-expired modal has no close affordance — the only action is to log
// back in. `onHide` is wired to a no-op so the primitive's close button still
// resolves to a function but the modal stays open until the user clicks "Log
// in", matching the legacy modal which omitted the close button entirely.
const noop = () => {};

const SessionExpiredModal = ({ show, onConfirm }) => (
  <Modal
    show={show}
    onHide={noop}
    title="Session expired"
    size="md"
    footer={
      <div className="sb-sidebar__modal-footer sb-sidebar__modal-footer--end">
        <Button variant="primary" onClick={onConfirm}>
          Log in
        </Button>
      </div>
    }
  >
    <p className="sb-sidebar__modal-body">
      Please log in again to continue using the app.
    </p>
  </Modal>
);

export default memo(SessionExpiredModal);
